import {Grid, IconButton, Tooltip} from '@material-ui/core'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import InfoIcon from '@material-ui/icons/Info'
import SettingsIcon from '@material-ui/icons/Settings'
import TuneIcon from '@material-ui/icons/Tune'
import ReportsMenu from 'modules/reports/components/Menu'
import ReportsMenuItem from 'modules/reports/components/Menu/Item'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsNav.styles'
import ReportsBreadcrumbs, {Breadcrumb} from 'modules/reports/components/Breadcrumbs'

type Props = {
  breadcrumbs?: Breadcrumb[]
}

function ReportsNav(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'Nav')

  const homeBreadcrumb: Breadcrumb = {href: '/reports', label: pt('title')}
  const breadcrumbs: Breadcrumb[] = [homeBreadcrumb, ...(props.breadcrumbs || [])]

  return (
    <Grid
      className={classes.root}
      container
      direction="row"
      justify="space-between"
      alignItems="center"
    >
      <ReportsBreadcrumbs breadcrumbs={breadcrumbs} data-testid={p('breadcrumbs')} />

      <div>
        <Tooltip title={pt('info.title')}>
          <IconButton
            className={classes.iconButton}
            aria-label={pt('info.title')}
            data-testid={p('info')}
          >
            <InfoIcon className={classes.iconButtonIcon} />
          </IconButton>
        </Tooltip>

        <ReportsMenu
          trigger={({ariaProps, open}) => (
            <Tooltip title={pt('settings.title')}>
              <IconButton
                className={classes.iconButton}
                onClick={open}
                aria-label={pt('settings.title')}
                data-testid={p('menu-trigger')}
                {...ariaProps}
              >
                <SettingsIcon className={classes.iconButtonIcon} />
              </IconButton>
            </Tooltip>
          )}
        >
          <ReportsMenuItem
            href="/reports/settings"
            icon={<TuneIcon />}
            data-testid={p('menu-settings')}
          >
            {pt('settings.dropdown.user-settings')}
          </ReportsMenuItem>

          <ReportsMenuItem
            href="/reports/scheduled"
            icon={<CalendarTodayIcon />}
            data-testid={p('menu-scheduled-reporting')}
          >
            {pt('settings.dropdown.scheduled-reporting')}
          </ReportsMenuItem>
        </ReportsMenu>
      </div>
    </Grid>
  )
}

export default ReportsNav
